import { useSetRecoilState, useRecoilValue } from "recoil";
import { failedRequestsQueueState } from "recoils/common/commonState";

const useFailedRequests = () => {
  const setFailedRequestsQueue = useSetRecoilState(failedRequestsQueueState);
  const failedRequestsQueue = useRecoilValue(failedRequestsQueueState);

  const addRequestToQueue = (request) => {
    setFailedRequestsQueue((prevQueue) => [...prevQueue, request]);
  };

  const clearQueue = () => {
    setFailedRequestsQueue([]);
  };
  return { failedRequestsQueue, addRequestToQueue, clearQueue };
};

export default useFailedRequests;
